'use strict';
module.exports = {
	'testing': {title: 'Testing: Colors', args: ['testing']},
	'testingWithIcons': {title: 'Testing: Flat Icons', args: ['testing', '/assets/progress/', 'flat', 25]},
	'testingWith3DIcons': {title: 'Testing: 3D Icons', args: ['testing', '/assets/progress/', '3d', 64]},
	'tasks': {title: 'Tasks: Colors', args: ['tasks']},
	'tasksWithIcons': {title: 'Tasks: Flat Icons', args: ['tasks', '/assets/progress/', 'flat', 25]},
	'tasksWith3DIcons': {title: 'Tasks: 3D Icons', args: ['tasks', '/assets/progress/', '3d', 64]}
};

